<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "CompanyForm",
  components: {
    AdminForm
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        // company_type_id: null,
        // company_group_id: null
      },
      isBusy: false
    };
  },
  computed: {
    options: function() {
      return {
        company_type_id_options: this.$store.getters[
          "company_type/getAll"
        ].selectOptions("id", "name"),
        company_group_id_options: this.$store.getters[
          "company_group/getAll"
        ].selectOptions("id", "name")
      };
    }
  },
  mounted() {
    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true
        })
        .then(() => {
          let item = _.cloneDeep(
            this.$store.getters[config.storeNamespace + "/getItem"](id)
          );
          this.form = {
            ...item,
            company_type_id: item.company_type ? item.company_type.id : null,
            company_group_id: item.company_group ? item.company_group.id : null
          };
          this.isBusy = false;
        });
    }

    this.$store.dispatch("company_type/getAll");
    this.$store.dispatch("company_group/getAll");
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Company/CompanyForm.vue